module.exports = __webpack_public_path__ + "static/img/16.343ac51.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/sp/16.png
// module id = AA5+
// module chunks = 0